import { render } from "./SustainabilityNavBar.vue?vue&type=template&id=a87d710a&scoped=true"
import script from "./SustainabilityNavBar.vue?vue&type=script&lang=js"
export * from "./SustainabilityNavBar.vue?vue&type=script&lang=js"

import "./SustainabilityNavBar.vue?vue&type=style&index=0&id=a87d710a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87d710a"]])

export default __exports__